import toast from "react-hot-toast";
import { axiosInstance } from "../components/lib/axios";


export const getUtilityData = async (pageNumber, pageSize, search, field) => {
    try {

        const params = new URLSearchParams();
        params.append('field', field);
        params.append('search', search);
        params.append('pageSize', pageSize);
        params.append('pageNumber', pageNumber);

        const res = await axiosInstance.get(`/utility?${params.toString()}`)
        // toast.success("Successfully fetched!");
        return res.data.data
        // console.log("lorem")

    } catch (err) {
        console.log(err.response?.data?.message)
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
}
